<template>
    <TheLayout>
        <div class="box-loading" v-if="loading">
            <div class="loading">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
        </div>

        <titlePage :title="title" :items="items"/>

        <div class="row mt-2">
            <div class="col-lg-4">
                <h5><b>Thêm mới quyền vào nhóm quyền</b></h5>
                <p>Cho phép Develop thêm mới các quyền truy cập vào nhóm quyền để cấu hình phân quyền cho trang.</p>
            </div>
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group">
                            <label>Tên nhóm quyền <sup class="text-danger"> * </sup></label>
                            <b-form-input
                                type="text"
                                placeholder="VD: Quản lý khách hàng"
                                v-model="dataGroup.permissionGroupName"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-1">
            <div class="col-lg-4">
                <h5><b>Các quyền chi tiết</b></h5>
                <p>Cho phép Develop thêm quyền vào trong hệ thống</p>
                <p>VD:</p>
<pre>[
  {
    "description": "Quản lý khách hàng",
    "permissionName": "Danh sách khách hàng",
    "permissionCode": "DS_KHACH_HANG"
  },
  ...
]</pre>
            </div>
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group">
                            <label>Json quyền <sup class="text-danger"> * </sup></label>
                            <b-form-textarea
                                placeholder="Json quyền"
                                v-model="dataGroup.permissionJson"
                                rows="10"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-right">
            <b-button 
              @click="initPermissions" 
              class="btn btn-default"
            >
              Xác nhận thông tin
            </b-button>
        </div>
        <b-modal
            id="modal-errors"
            class="modalDialog"
            hide-header
            hide-footer
            centered
            no-close-on-backdrop
        >
            <button
                type="button"
                aria-label="Close"
                class="close close-ext"
                @click="$bvModal.hide('modal-errors')"
            >
            ×
            </button>
            <div class="box-modal d-flex flex-column align-items-center">
                <div class="box-img-modal">
                    <img src="@/assets/images/icon-modal-warning.svg"/>
                </div>
                <div class="box-right-modal">
                    <div class="text-title-modal color-danger color_wrn">
                      Thông báo lỗi
                    </div>
                    <div class="text-des-modal text-secondary">
                        {{txtErrors}}
                    </div>
                </div>
            </div>

            <b-button 
              @click="$bvModal.hide('modal-errors')" 
              class="btn btn-default btn-default-ext pull-right"
            >
              Quaylại
            </b-button>
        </b-modal>
    </TheLayout>
</template>
<script>
  import titlePage from '@/components/title-page'
  import {RoleService} from '@/services/nextshop/role.service'

  export default {
    components: {
      titlePage
    },
    data() {
      return {
        inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
        loading: false,
        title: "THÊM MỚI QUYỀN VÀO NHÓM QUYỀN",
        dataGroup: {},
        txtErrors: '',
        items: [
          {
            text: "Vai trò",
            href: '/role',
          },
          {
            text: "Thêm mới quyền",
            active: true,
          }
        ]
      }
    },

    methods: {
      async initPermissions() {
        if(this.dataGroup.permissionJson !== undefined && this.dataGroup.permissionGroupName !== undefined) {
          const params = {
            appId: process.env.VUE_APP_ID,
            createBy: this.inforAccount.username,
            permissions: JSON.parse(this.dataGroup.permissionJson),
            groupName: this.dataGroup.permissionGroupName
          }

          const dataRes = await RoleService.initPermissions(params)
          if (dataRes.success) {
            this.$router.push("/role")
          } else {
            this.txtErrors = dataRes.errors[0].message
            this.$bvModal.show('modal-errors')
          }
        }else{
          this.txtErrors = 'Vui lòng điền các trường bắt buộc!'
          this.$bvModal.show('modal-errors')
        }
      }
    }
  }
</script>
<style scoped>
    .btn-default-ext {
        color: #222 !important;
        background: #F1F2F4 !important;
        border: 1px solid #F1F2F4 !important;
    }
    .box-img-modal {
        text-align: center;
    }
    .box-img-modal img {
        width: 55%;
    }
    .color_wrn {
        color: #F6AB2F !important;
    }
</style>
